<!-- =========================================================================================
    File Name: tableFilterSorter.vue
    Description: Add filter and sorting functionality to table
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <b-overlay
      :show="show"
      :variant="variant"
      :opacity="opacity"
      :blur="blur"
      rounded="lg"
      spinner-variant="primary"
    >
      <b-card>
        <h4 class="float-left">{{ $t("Surveillanc") }}</h4>
        <div class="mt-20" v-if="rooms.length > 0">
          <div class="vx-row">
            <div
              class="vx-col md:w-1/2 w-1/2 mb-8"
              v-for="(room, index) in rooms"
              :key="index"
              :id="'room-' + index"
            >
              <div v-if="room" :id="'container' + room.room_name">
                <span :id="room.room_name"><b>Device : </b> NA</span>
                <button
                  :disabled="appId[room.room_name] != '' ? false : true"
                  class="btn primary btn-primary float-right mb-1"
                  @click="stopMeeting(room.room_name)"
                >
                  Stop Meeting
                </button>
                <b-button
                  :id="'timer' + index"
                  type="filled"
                  class="timer float-right mr-2 border-primary text-primary"
                  variant="border"
                  >{{ formatted[index] }}</b-button
                >
                <div :id="'meet' + index"></div>
              </div>
            </div>
          </div>
          <iframe src="https://unio.bip.it/inv.html" style="display: none" />
        </div>
        <div v-else>
          <div class="mt-10 text-center ">
            <h5>{{ $t("RoomsNotAvailable") }}</h5>
          </div>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>
<style>
iframe {
  border: 1px solid gray !important;
}
.mb-8 {
  margin-bottom: 1.6rem !important;
}
</style>
<script>
import moment from "moment";
import $ from "jquery";

export default {
  data() {
    return {
      rooms: [],
      api: [],
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
      appId: [],
      displayTimer: [],
      formatted: [],
      isRunning: [],
      startTime: [],
      timerValue: [],
      overallTime: [],
      stopTimer: [],
      roomsAvailabel: [],
      showEmpty: false,
    };
  },
  created() {
    //const res1 = fetch('https://unio.bip.it/inv.html');
    this.getRooms();

    Echo.channel("deviceLeft").listen("DeviceLeft", async (response) => {
      const index = this.roomsAvailabel.indexOf(response.data.room_name);
          if (index != -1) {
              this.stopMeeting(response.data.room_name, false)
          }     
    });

    Echo.channel("Devicejoined").listen("DeviceJoined", async (response) => {
      var exist = false;
      var currentPosition = null;
      var position = null;
      this.rooms.forEach((element, index) => {
        if (element.room_name == response.data.room_name) {
          if (!$("#meet" + index).html()) {
              exist = false;
              currentPosition = index;
          } else {
            exist = true;
          }         
        }
      });

      if (!exist) {
        if(currentPosition) {
           delete this.rooms[currentPosition];
           $('#room-' + currentPosition).remove();
        }
        
        this.rooms.push(response.data);
        position = this.rooms.length - 1;

        setTimeout(() => {
          this.autoConnect(response.data, position);
        }, 2000);
      }
    });
  },

  beforeDestroy(){
      this.appId = [];
      this.displayTimer = [];
      this.formatted = [];
      this.isRunning = [];
      this.startTime = [];
      this.timerValue = [];
      this.overallTime = [];
      this.roomsAvailabel = [];
      this.showEmpty = false;
      this.stopTimer.forEach(element => {
        console.log('---------------clear interval------------------');
        clearInterval(element);
      });      
  },

  methods: {
    /**
     *  getstaffs method get all companies from company list
     **/
    getRooms() {
      this.success = "";
      this.error = "";
      this.show = true;
      this.$store
        .dispatch("GetRooms", this.$store.getters.currentUser.id)
        .then((res) => {
          this.show = false;
          this.rooms = res.data.data;

          setTimeout(() => {
            this.connectToRooms();
          }, 1000);

          // call get api
          setTimeout(() => {
            this.getRoomDeviceDetails();
          }, 5000);
        })
        .catch((error) => {
          this.$log.error(
            "File : Show.vue | Function : getRooms() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },

    /**
     * connect to rooms
     */
    connectToRooms() {
      this.showEmpty = false;
      this.rooms.forEach((element, index) => {
        if (!$("#meet" + index).html()) {
          console.log("sadada------", document.querySelector("#meet" + index));
          this.$set(this.appId, element.room_name, "");
          // stop timer
          this.timerValue[index] = false;
          this.displayTimer[index] = false;
          this.stop(index);
          this.reset(index);
          this.$set(this.roomsAvailabel, index , element.room_name);
          const domain = element.room_domain;
          const options = {
            roomName: element.room_name,
            parentNode: document.querySelector("#meet" + index),
            height: 347,
            configOverwrite: {
              startWithAudioMuted: true,
              startWithVideoMuted: true,
              startSilent: true,
            },
            interfaceConfigOverwrite: {
              MOBILE_APP_PROMO: true,
              DISABLE_JOIN_LEAVE_NOTIFICATIONS: true,
              DISABLE_PRESENCE_STATUS: true,
              DISABLE_RINGING: true,
              HIDE_INVITE_MORE_HEADER: true,
              TOOLBAR_BUTTONS: ["tileview"],
            },
          };
          this.api[index] = new JitsiMeetExternalAPI(domain, options);

          //timer
          this.initTimer(element, index);

          // When user left
          this.api[index].on("participantLeft", (res) => {
            if (this.api[index]._numberOfParticipants == 1) {
              console.log("-----------participantLeft---------------");
              this.clearData(element.room_name);
            }
          });

          this.api[index].on("videoConferenceJoined", (res) => {
            console.log("-----------videoConferenceJoined---------------");
           
            const listener = ({ enabled }) => {
              this.api[index].removeEventListener(`tileViewChanged`, listener);

              if (!enabled) {
                this.api[index].executeCommand(`toggleTileView`);
              }
            };

            this.api[index].addEventListener(`tileViewChanged`, listener);
            this.api[index].executeCommand(`toggleTileView`);
          });

          if (element.pin) {
            // set new password for channel
            this.api[index].addEventListener(
              "participantRoleChanged",
              function (event) {
              if (event.role == 'moderator')
                this.executeCommand("password", element.pin);
              }
            );

            // join a protected channel
            this.api[index].on("passwordRequired", function () {
              this.executeCommand("password", element.pin);
            });
          }
        }
      });
    },

    /**
     * auto connect
     */
    autoConnect(element, index) {
      if (!$("#meet" + index).html()) {
        this.showEmpty = false;
        console.log("sadada------", document.querySelector("#meet" + index));
        this.$set(this.appId, element.room_name, "");
        this.timerValue[index] = false;
        this.displayTimer[index] = false;
        this.stop(index);
        this.reset(index);
        this.$set(this.roomsAvailabel, index , element.room_name);
        const domain = element.room_domain;
        const options = {
          roomName: element.room_name,
          parentNode: document.querySelector("#meet" + index),
          height: 347,
          configOverwrite: {
            startWithAudioMuted: true,
            startWithVideoMuted: true,
            startSilent: true,
          },
          interfaceConfigOverwrite: {
            MOBILE_APP_PROMO: true,
            DISABLE_JOIN_LEAVE_NOTIFICATIONS: true,
            DISABLE_PRESENCE_STATUS: true,
            DISABLE_RINGING: true,
            HIDE_INVITE_MORE_HEADER: true,
            TOOLBAR_BUTTONS: ["tileview"],
          },
        };

        this.api[index] = new JitsiMeetExternalAPI(domain, options);

        // timer
        this.initTimer(element, index);
        
        // When user left
        this.api[index].on("participantLeft", (res) => {
          if (this.api[index]._numberOfParticipants == 1) {
            console.log("-----------participantLeft---------------",$("#container" + element.room_name));
            this.clearData(element.room_name);
            console.log("-----------participantLeft---------------",this.appId);
          }
        });

        this.api[index].on("videoConferenceJoined", (res) => {
          console.log("-----------videoConferenceJoined---------------");
          
          const listener = ({ enabled }) => {
            this.api[index].removeEventListener(`tileViewChanged`, listener);

            if (!enabled) {
              this.api[index].executeCommand(`toggleTileView`);
            }
          };

          this.api[index].addEventListener(`tileViewChanged`, listener);
          this.api[index].executeCommand(`toggleTileView`);
        });

        if (element.room_pin) {
          // set new password for channel
          this.api[index].addEventListener(
            "participantRoleChanged",
            function (event) {
              if (event.role == 'moderator')
              this.executeCommand("password", element.room_pin);
            }
          );

          // join a protected channel
          this.api[index].on("passwordRequired", function () {
            this.executeCommand("password", element.room_pin);
          });
        }
      }
    },

    /**
     * connected device details
     */
    getRoomDeviceDetails() {
      this.$store
        .dispatch("GetRoomsDeviceInfo")
        .then((res) => {
          console.log("res.data", res.data.data);
          res.data.data.forEach((element) => {
            $("#" + element.room_name).html(
              "<b>Device</b> : " + element.device_name
            );
            this.$set(this.appId, element.room_name, element.appointment_id);
            console.log("-------response---------", $("#" + element.room_name));
          });
        })
        .catch((error) => {
          return false;
        });
    },

    /**
     * stop meeting
     */
    stopMeeting(room, msg = true) {
      this.show = true;
      var data = {
        id: this.appId[room],
      };
      this.$store
        .dispatch("stopMeeting", data)
        .then((res) => {
          this.show = false;
          this.clearData(room);
          console.log("-------stop meeting event--------");
          if(msg){
          this.$toasted.show(this.$t("MeetingStop"), {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          });
          }
        })
        .catch((error) => {
          this.show = false;
          return false;
        });
    },

    start(index) {
        if (this.isRunning[index]) {
          return console.error("Timer is already running");
        }

        this.isRunning[index] = true;
        this.startTime[index] = Date.now();
    },

    getTime(index) {
      if (!this.startTime[index]) {
        return 0;
      }

      if (this.isRunning) {
        return (
          this.overallTime[index] + this._getTimeElapsedSinceLastStart(index)
        );
      }
      return this.overallTime[index];
    },

    /** TIMER FUNCTIONS */
    _getTimeElapsedSinceLastStart(index) {
      if (!this.startTime[index]) {
        return 0;
      }

      return Date.now() - this.startTime[index];
    },

    /**
     * timer functions
     * **/
    startTimers(duration, room_name, index) {
      // let index = this.rooms.findIndex(
      //   (element) => element.room_name == room_name
      // );

      this.start(index);
      this.displayTimer[index] = true;
      this.timerValue[index] = true;
      let timer = duration;
      console.log('this.startTime[index]----',this.startTime[index]);
      this.stopTimer[index] = setInterval(() => {
        let obj = this;
        const timeInSeconds = timer - Math.round(this.getTime(index) / 1000);

        if (timeInSeconds > 0) {
          var min = Math.floor(timeInSeconds / 60),
            remSec = timeInSeconds % 60;

          if (remSec < 10) {
            remSec = "0" + remSec;
          }
          if (min < 10) {
            min = "0" + min;
          }
          let formatted = min + ":" + remSec;
          console.log('----------formatted value-------------', index);
          $("#timer" + index).html(formatted);
        }

        if (timeInSeconds == 0) {
          this.clearData(room_name);
        }
      }, 102);
    },

    stop(index) {
      if (!this.isRunning[index]) {
        return console.error("Timer is already stopped");
      }

      this.isRunning[index] = false;
      this.overallTime[index] =
        this.overallTime[index] + this._getTimeElapsedSinceLastStart(index);
    },

    reset(index) {
      this.overallTime[index] = 0;
      if (this.isRunning[index]) {
        this.startTime[index] = Date.now();
        return;
      }
      this.startTime[index] = 0;
      console.log('this.stopTimer[index]----',this.stopTimer[index]);
      clearInterval(this.stopTimer[index]);
      $("#timer" + index).html("NA");
    },

    startTimerWithappointmentId(appointment_id, room_name, index) {
      var data = {
        appointment_id: appointment_id,
        is_device: 1,
      };

      this.$store
        .dispatch("getDepartmentDuration", data)
        .then((res) => {
          var duration = res.data.data.remaining_time;
          console.log('------duration--------', duration);
          this.startTimers(duration, room_name, index);
        })
        .catch((error) => {
          return false;
        });
    },

    // clear data
    clearData(room) {
      console.log('--------clear data-----------', room);
      // When user left
      this.$set(this.appId, room, "");
      $("#container" + room).parent().remove();
      var i = -1;
      var index = i;
      while ((i = this.roomsAvailabel.indexOf(room, i+1)) != -1){
        this.roomsAvailabel.splice(i, 1);
        index = i;
        // stop timer
        this.timerValue[index] = false;
        this.displayTimer[index] = false;
        this.stop(index);
        this.reset(index);
      }

      var filtered = this.roomsAvailabel.filter(function (el) {
          return el != null;
      });
      
      //console.log('------------', filtered);

      if (filtered.length <= 0) {
        this.showEmpty = true;
        //console.log('-----------Empty-----------');
        this.rooms = [];
      }
    },

    // init timer
    initTimer(element, index) {
      this.formatted[index] = 'NA';
      this.isRunning[index] = false;
      this.startTime[index] = 0;
      this.timerValue[index] = true;
      this.overallTime[index] = 0;
      this.displayTimer[index] = false;
      console.log('--------------Init Timer-----------', index);
      this.startTimerWithappointmentId(element.appointment_id,element.room_name,index);
      this.$set(this.appId,element.room_name,element.appointment_id);
      if(element.device_name)
        $("#" + element.room_name).html("<b>Device</b> : " + element.device_name);
    }
  },
};
</script>

<style lang="stylus" scope></style>